export default {"src":"/_next/static/media/cities.15576232.svg","height":50,"width":51};